module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container product"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('h2', [_vm._v("Customize Your Order")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n                        Enter an inscription below to customize your paver.\n                        Each line allows for " + _vm._s(_vm.info.max_chars) + " characters per line.\n                        View our "), _c('a', {
    staticClass: "text-danger underline pointer",
    on: {
      "click": function($event) {
        _vm.showInscriptionGuidelines()
      }
    }
  }, [_vm._v("inscription policy")]), _vm._v(" for more information.\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "prod-container"
  }, [_c('img', {
    staticClass: "prod-img",
    attrs: {
      "src": _vm.getProductImage(_vm.logo)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prod-replica"
  }, [_c('div', {
    staticClass: "prod-replica-table"
  }, [_c('div', {
    staticClass: "prod-replica-table-td",
    class: _vm.product.classes
  }, _vm._l((_vm.product.max_lines), function(n) {
    return _c('p', [_vm._v(_vm._s(_vm.lines[n - 1]))])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  }), _vm._v(" "), _c('h4', [_vm._v("$ " + _vm._s(_vm.product.price))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Brick Inscription:")]), _vm._v(" "), _c('div', {
    staticClass: "brick-text-form"
  }, _vm._l((_vm.product.max_lines), function(n) {
    return _c('div', {
      staticClass: "form-group row no-gutter"
    }, [_c('div', {
      staticClass: "col-md-2"
    }, [_c('label', {
      attrs: {
        "for": 'l-' + n
      }
    }, [_vm._v("Line " + _vm._s(n) + ":")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "line-id": 'l-' + n,
        "id": 'l-' + n,
        "maxlength": _vm.product.max_characters,
        "size": _vm.product.max_characters
      },
      domProps: {
        "value": _vm.lines[n - 1]
      },
      on: {
        "keydown": function($event) {
          _vm.withAnyKeyDown($event)
        },
        "keyup": function($event) {
          _vm.withAnyKeyUp($event)
        },
        "input": function($event) {
          _vm.withInput($event)
        }
      }
    })])])
  })), _vm._v(" "), _c('p', [_vm._v("Need inspiration?\n                            "), _c('a', {
    staticClass: "text-danger pointer",
    on: {
      "click": function($event) {
        _vm.showInscriptionExamples()
      }
    }
  }, [_vm._v("Click here")]), _vm._v("\n                            for inscription examples.\n                        ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.isMultiLogoAllowed) ? _c('preferred-logo', {
    ref: "preflog",
    attrs: {
      "options": _vm.product.options || {},
      "logo": _vm.logo,
      "on-logo-change": "onProductLogoChange"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.item_id > 0) ? [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("ADDITIONAL ITEMS")]), _vm._v(" "), _c('p', [_vm._v("\n                        Bring your Prosper ISD pride home with keepsake items that proudly showcase your personalized message.\n                        These special edition items are perfect gifts for graduations, holidays, birthdays and more!\n                        Replica bricks are made with the same material and message as your installed Stadium Brick.\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.baseProductChildren), function(child, childIndex) {
    return _c('div', {
      staticClass: "col-sm-4 text-center"
    }, [_c('div', {
      staticClass: "img-box"
    }, [_c('div', {
      class: {
        'img-wrap': !_vm.is4x8(child.item_image_blank || ''),
          'img-wrap-4x8': _vm.is4x8(child.item_image_blank || '')
      }
    }, [_c('div', {
      staticClass: "prod-container"
    }, [_c('img', {
      staticClass: "prod-img",
      attrs: {
        "src": _vm.getChildImage(child, _vm.logo)
      }
    }), _vm._v(" "), ((child.item_type === 2 || child.item_type === 4)) ? _c('div', {
      staticClass: "prod-replica"
    }, [_c('div', {
      staticClass: "prod-replica-table"
    }, [_c('div', {
      staticClass: "prod-replica-table-td",
      class: child.classes
    }, _vm._l((_vm.product.max_lines), function(n) {
      return _c('p', [_vm._v(_vm._s(_vm.lines[n - 1]))])
    }))])]) : _vm._e()])])]), _vm._v(" "), _c('p', {
      staticClass: "product-title text-left"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(child.description)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row wrap-count"
    }, [_c('div', {
      staticClass: "col-xs-6 text-left"
    }, [_vm._v("$" + _vm._s(child.price))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 text-right"
    }, [_c('div', {
      staticClass: "amount no-select"
    }, [_c('span', {
      staticClass: "pointer",
      on: {
        "click": function($event) {
          _vm.sub1(child.item_id)
        }
      }
    }, [_vm._v("-")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.qtys[child.item_id]))]), _vm._v(" "), _c('span', {
      staticClass: "pointer",
      on: {
        "click": function($event) {
          _vm.add1(child.item_id)
        }
      }
    }, [_vm._v("+")])])])])])
  }))] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "btn-wrap"
  }, [_c('a', {
    staticClass: "btn btn-danger btn-lg pull-right",
    attrs: {
      "disabled": _vm.item_id == 0
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("Add to cart")])])])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("\n                            * This image is for representation only and is not an exact reflection of your completed brick (please refer to About page).\n                            All materials subject to change based on final architectural design.\n                        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-515ddbfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/Product.vue
// module id = 9qKv
// module chunks = 1